import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { UserDefinedCodesLayout,UserDefinedReferencesLayout } from '../Layout';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import {UserDefinedLayout} from '../Layout';
import { IM, WM } from "../../../../const/constants";

function UserDefinedTab(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;

    const handleFieldChangeCodes = useCallback((name, value, e) => {

    }, []);

    const handleFormLoadReference = useCallback((name, value, e) => {

    }, []);

    const handleDimensionFormLoadCodes = useCallback(() => {

    }, []);
    return (
        <>
            <div>
                <TabPanel className="TabpanelContainer">
                    <TabItem title="Codes">
                        <FormField
                            currrentUser={currentUser}
                            layoutId={props.Module===WM?'39D9EFC0-CB4A-4E27-9A30-317D0919C5CB':'0EFB3A53-4D34-4A44-8428-D77966C5AC85'}
                            layoutName='DimensionsForm'
                            defaultFormSchema={UserDefinedCodesLayout}
                            formFields={props.formFields}
                            setformFields={props.setformFields}
                            handleFieldValueChange={handleFieldChangeCodes}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={props.formRefs}
                            onFormLoad={handleDimensionFormLoadCodes}
                            handleSelectedItemChange={handleFieldChangeCodes}
                        />
                    </TabItem>
                    <TabItem title="References">
                        <FormField
                            currrentUser={currentUser}
                            layoutId='C1BCA2E5-5E1B-4092-BD9E-38E04E1A36A5'
                            layoutName='ReferenceForm'
                            defaultFormSchema={UserDefinedReferencesLayout}
                            formFields={props.formFields}
                            setformFields={props.setformFields}
                            handleFieldValueChange={handleFieldChangeCodes}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={props.formRefs}
                            onFormLoad={handleFormLoadReference}
                            handleSelectedItemChange={handleFieldChangeCodes}
                        />
                    </TabItem>

                </TabPanel>
            </div>
        </>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UserDefinedTab);